import React, { useContext } from "react";

import { ActionDropdown } from "../ActionDropdown/ActionDropdown";
import {
  roles,
  statusPrestationsValues,
  subRoles,
  subStatus,
} from "../../../utils/constants";
import { ActionRoleSpecific, onlyRoleMapping } from "../../../engine/AuthRoute";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { RiBillLine, RiDeleteBinLine } from "react-icons/ri";
import { MdPublishedWithChanges } from "react-icons/md";
import { FcCancel } from "react-icons/fc";
import {
  dangerousUpdate,
  deletePrestation,
  duplicatePrestation,
  getPrestation,
  setPropertiesPrestation,
  updatePrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import {
  confirmCancelPrestation,
  confirmDeletePrestation,
  confirmDuplicatePrestation,
  modalsByContext,
} from "../Modals/modals";
import DownloadICS from "../DownloadICS/DownloadICS";
import dayjs from "../../../utils/dayjs";
import { UserContext } from "../../../engine/context/User.context";
import { BiDuplicate } from "react-icons/bi";
import { PrestationCancel } from "../Modals/PrestationCancel";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { TbFileTypePdf, TbPlayerTrackNextFilled } from "react-icons/tb";
import routes from "../../../engine/routes";
import {
  FaCheck,
  FaCheckDouble,
  FaRegComments,
  FaRegFilePdf,
} from "react-icons/fa";
import useDocumentCreator from "../../../engine/hooks/useDocumentCreator";
import { http } from "../../../engine/api/http";
import { GrUserAdmin } from "react-icons/gr";
import { AiOutlineGateway } from "react-icons/ai";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

export const PrestationAction = ({}) => {
  const { t } = useTranslation();
  const { prestation, loading } = useSelector(state => state.prestation);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useContext(UserContext);
  const context = useContext(ModalContext);

  const [get, createAndGet, isLoading, setUrl, doc] = useDocumentCreator();
  const [disabled] = usePrestationDisabler();

  const getPdf = () => {
    createAndGet(
      { bills: [prestation.bill._id], language: i18n.language },
      `bills/${prestation.bill._id}/pdf`,
      true,
      true,
      () => {},
    );
  };

  const { status, _id } = prestation;

  const deleteDraftPrestation = () => {
    confirmDeletePrestation({
      onOk: () => {
        dispatch(deletePrestation());
      },
    });
  };

  const duplicatePrestationClick = () => {
    confirmDuplicatePrestation({
      onOk: () => {
        dispatch(duplicatePrestation());
      },
    });
  };

  const goToBill = () => {
    navigate(routes.billing(prestation.bill._id).edition.path);
  };

  let isCanceledClient =
    [statusPrestationsValues.cancelClient].includes(prestation.status) ||
    [subStatus.institution].includes(prestation.subStatus);

  let isFinish = [
    statusPrestationsValues.finish,
    statusPrestationsValues.finish_notsigned,
    statusPrestationsValues.finish_permanance,
  ].includes(prestation.status);

  let isCancelInterprete =
    [statusPrestationsValues.cancelInterprete].includes(prestation.status) ||
    [subStatus.interprete].includes(prestation.subStatus);

  const blue = "#1a61c4";
  const size = 18;
  const handlePrint = () => {
    try {
      // Get the Base64 string (assuming it's a valid image)
      const base64Image = prestation?.interventionFinal?.signing;

      document.title = t("prestation") + " " + prestation.reference; // Adjust the title as needed

      const canvasElement = document.querySelector(".printPDF");
      // const canvasElement = document.getElementById("SignatureCanvas");


      // If the Base64 image string is available
      if (base64Image && canvasElement) {
        // Create an image element
        const imgElement = document.createElement("img");
        imgElement.src = `${base64Image}`;
        imgElement.alt = "Signature";
        imgElement.style.width = "500px";
        imgElement.style.height = "100px";
        // imgElement.style.marginTop = "-10px";
        imgElement.style.display = "block";
        imgElement.style.zIndex = "100000";

        // Find the canvas with class "sigCanvas"

        // If the canvas element exists, insert the image after it
        if (canvasElement) {
          canvasElement.insertAdjacentElement("afterend", imgElement);
          canvasElement.remove();
        }
      }

      // Remove all elements with the class "non-printable"
      document
        .querySelectorAll(".non-printable")
        .forEach(element => element.remove());

      const printContents = document.getElementById("printable").innerHTML;
      const originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;
      window.print();
      //document.body.innerHTML = originalContents;
      window.location.reload(); // Reload the page to reset the content
    } catch (e) {
      console.log(e);
    }
  };

  return (
    prestation._id !== undefined && (
      <>
        <ActionDropdown loading={isLoading || loading}>
          <ActionRoleSpecific
            only={[
              roles.admin,
              roles.permanance,
              subRoles.institutionAdmin,
              subRoles.institutionDemander,
            ]}
            key={"Supprimer la prestation"}
          >
            {status === statusPrestationsValues.draft &&
            onlyRoleMapping([
              roles.admin,
              roles.permanance,
              subRoles.institutionAdmin,
              subRoles.institutionDemander,
            ]) ? (
              <a onClick={deleteDraftPrestation} key={"deletePres"}>
                <span style={{ marginLeft: 5, marginRight: 10 }}>
                  <RiDeleteBinLine size={size} color={"red"} />
                </span>
                {t("prestationAction.deletePrestation")}
              </a>
            ) : null}
          </ActionRoleSpecific>

          <ActionRoleSpecific
            only={[roles.permanance]}
            key={"Modifier la prestation"}
          >
            {(status === statusPrestationsValues.planned ||
              status === statusPrestationsValues.waiting) &&
            onlyRoleMapping([roles.permanance]) ? (
              <a
                key={"updatePresta"}
                onClick={() => {
                  dispatch(dangerousUpdate());
                }}
              >
                <span style={{ marginLeft: 5, marginRight: 10 }}>
                  <MdPublishedWithChanges size={size} color={blue} />
                </span>
                {t("prestationAction.modifyPrestation")}
              </a>
            ) : null}
          </ActionRoleSpecific>

          <ActionRoleSpecific
            only={[roles.admin]}
            key={"Modifier la prestation admin"}
          >
            {onlyRoleMapping([roles.admin]) ? (
              <a
                key={"updatePresta"}
                onClick={() => {
                  dispatch(dangerousUpdate());
                }}
              >
                <span style={{ marginLeft: 5, marginRight: 10 }}>
                  <MdPublishedWithChanges size={size} color={blue} />
                </span>
                {t("prestationAction.modifyPrestation")}
              </a>
            ) : null}
          </ActionRoleSpecific>

          {onlyRoleMapping([roles.admin, roles.permanance]) ? (
            <a onClick={duplicatePrestationClick} key={"Annuler"}>
              <span style={{ marginLeft: 5, marginRight: 10 }}>
                <BiDuplicate color={blue} size={size} />
              </span>
              {t("prestationAction.duplicatePrestation")}
            </a>
          ) : null}

          {_id !== undefined &&
          onlyRoleMapping([roles.admin, roles.permanance]) ? (
            <a
              disabled={disabled}
              onClick={async () => {
                !disabled &&
                  context.openModal(modalsByContext.PrestationEditAdmin);
              }}
              className={disabled ? "disabled" : ""}
              key={modalsByContext.PrestationEditAdmin}
            >
              <span style={{ marginLeft: 5, marginRight: 10 }}>
                <FaRegComments color={blue} size={size} />
              </span>
              {t("prestationAction.modifyComment")}
            </a>
          ) : null}

          {_id !== undefined &&
          onlyRoleMapping([roles.admin, roles.permanance]) ? (
            <a
              onClick={async () => {
                context.openModal(modalsByContext.PrestationControl, {
                  control: 1,
                });
              }}
              key={modalsByContext.PrestationControl}
            >
              <span style={{ marginLeft: 5, marginRight: 10 }}>
                <FaCheck color={"green"} size={size} />
              </span>
              {t("prestationAction.firstControl")}
            </a>
          ) : null}

          {_id !== undefined &&
          onlyRoleMapping([roles.admin, roles.permanance]) ? (
            <a
              onClick={async () => {
                context.openModal(modalsByContext.PrestationControl, {
                  control: 2,
                });
              }}
              key={modalsByContext.PrestationControl}
            >
              <span style={{ marginLeft: 5, marginRight: 10 }}>
                <FaCheckDouble color={"green"} size={size} />
              </span>
              {t("prestationAction.secondControl")}
            </a>
          ) : null}

          {[
            statusPrestationsValues.finish,
            statusPrestationsValues.waiting,
            statusPrestationsValues.planned,
            statusPrestationsValues.finish_notsigned,
            statusPrestationsValues.finish_permanance,
            statusPrestationsValues.cancel,
            statusPrestationsValues.noReply,
          ].includes(status) &&
          onlyRoleMapping([roles.admin, roles.permanance]) ? (
            <a
              disabled={disabled}
              className={disabled ? "disabled" : ""}
              onClick={async () => {
                // const confirmed = await modal.confirm(config);
                !disabled &&
                  context.openModal(modalsByContext.PrestationCancel);
              }}
              key={modalsByContext.PrestationCancel}
            >
              <span style={{ marginLeft: 5, marginRight: 10 }}>
                <FcCancel color={"red"} size={size} />
              </span>
              {t("prestationAction.cancelPrestation")}
            </a>
          ) : null}

          {[
            statusPrestationsValues.waiting,
            statusPrestationsValues.planned,
          ].includes(status) &&
          onlyRoleMapping([
            //subRoles.institutionAdmin,
            //  subRoles.institutionDemander,
          ]) ? (
            <a
              onClick={async () => {
                context.openModal(modalsByContext.PrestationCancel);
              }}
              key={modalsByContext.PrestationCancel}
            >
              <span style={{ marginLeft: 5, marginRight: 10 }}>
                <FcCancel color={"red"} size={size} />
              </span>
              {t("prestationAction.cancelPrestation")}
            </a>
          ) : null}

          {onlyRoleMapping([roles.admin, roles.permanance]) &&
          prestation?.bill !== null ? (
            <a
              disabled={disabled}
              className={disabled ? "disabled" : ""}
              onClick={goToBill}
              key={"bill"}
            >
              <span style={{ marginLeft: 5, marginRight: 10 }}>
                <RiBillLine color={"#00377c"} size={size} />
              </span>
              {t("prestationAction.modifyBill")}
            </a>
          ) : null}

          {onlyRoleMapping(
            [roles.admin, roles.permanance],
            subRoles.institutionAdmin,
            subRoles.institutionDemander,
          ) && prestation?.bill !== undefined ? (
            <a onClick={getPdf} key={"getPdf"}>
              <span style={{ marginLeft: 5, marginRight: 10 }}>
                <FaRegFilePdf color={"black"} size={size} />
              </span>
              {t("prestationAction.downloadBill")}
            </a>
          ) : null}

          {status !== statusPrestationsValues.draft &&
          status !== statusPrestationsValues.waiting &&
          onlyRoleMapping([
            roles.admin,
            roles.permanance,
            // subRoles.institutionAdmin,
            // subRoles.institutionDemander,
          ]) ? (
            <a
              onClick={async () => {
                context.openModal(modalsByContext.PrestationFollow);
              }}
              key={modalsByContext.PrestationFollow}
            >
              <span style={{ marginLeft: 5, marginRight: 10 }}>
                <TbPlayerTrackNextFilled color={"black"} size={size} />
              </span>
              {t("prestationAction.createFollowup")}
            </a>
          ) : null}

          {prestation._id !== undefined ? <DownloadICS type={"link"} /> : null}

          <a onClick={handlePrint}>
            <span style={{ marginLeft: 5, marginRight: 10 }}>
              <TbFileTypePdf color={"black"} size={size} />
            </span>
            {t("quickExport")}
          </a>
        </ActionDropdown>
      </>
    )
  );
};
